import { ProduitType, recursiveFeatures } from '@innedit/innedit-type';
import { FeatureData, GenericData } from 'packages/innedit';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { change, FieldArray } from 'redux-form';

import { DataProduitsDimensionsProps } from '~/datas/props';
import { ReducersProps } from '~/reducers';

import { Box } from '../../../packages/formidable';
import DimensionsRender from './Render';

const DataProduitsDimensions: FC<DataProduitsDimensionsProps> = props => {
  const { espaceId, formName, name } = props;
  const dispatch = useDispatch();
  const values = useSelector(
    (globalState: ReducersProps<ProduitType>) =>
      globalState.form[formName].values,
  );

  const features: string[] =
    values && values.features ? recursiveFeatures(values.features) : [];
  const dimensions = values && values.dimensions;

  useEffect(() => {
    if (features.length > 0) {
      const featureData = new FeatureData({
        espaceId,
      });

      featureData
        .findByIds(features.slice(0, 9))
        .then(docs => {
          if (docs.length > 0) {
            // On récupére toutes les dimensions
            return docs.map(feature => {
              const featureDimensionData = new GenericData<any>({
                espaceId,
                collectionName: 'dimensions',
                parentCollectionName: 'features',
                parentId: feature.id,
              });

              return featureDimensionData
                .find({
                  wheres: {
                    deleted: false,
                    hidden: false,
                  },
                })
                .then(newDimensions => {
                  if (newDimensions) {
                    const tmpDimensions = dimensions ? [...dimensions] : [];
                    let addOne = false;
                    newDimensions.forEach(doc => {
                      if (
                        !dimensions ||
                        !dimensions.some(
                          (d: { id?: string }) => d.id && d.id === doc.id,
                        )
                      ) {
                        addOne = true;
                        const data: { [key: string]: any } = { ...doc };

                        delete data.espaceId;
                        delete data.createdAt;
                        delete data.datetime;
                        delete data.deleted;
                        delete data.hidden;
                        delete data.parent;
                        delete data.updatedAt;
                        tmpDimensions.push({
                          ...doc,
                          id: doc.id,
                          valeur: '',
                        });
                      }
                    });

                    if (addOne) {
                      dispatch(change(formName, 'dimensions', tmpDimensions));
                    }
                  }

                  return true;
                })
                .catch((error: Error) => {
                  console.error(error);
                });
            });
          }

          return true;
        })
        .catch((error: Error) => {
          console.error(error);
        });
    }
  }, [espaceId, features, dimensions, dispatch, formName]);

  return (
    <Box>
      <FieldArray component={DimensionsRender} name={name} props={props} />
    </Box>
  );
};

export default DataProduitsDimensions;
